import React, { useEffect, useState } from "react"
import "./style/EventsCard.scss"

export type Event = {
  id: number
  title: string
  date: string
  type: string
  status: "upcoming" | "past"
  location: string
}

const formatDate = (iso: string) => {
  const date = new Date(iso)
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric"
  })
}

const getCountdown = (targetDate: string): string => {
  const now = new Date()
  const target = new Date(targetDate)
  const diff = target.getTime() - now.getTime()

  if (diff <= 0) return "Live or ended"

  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
  const mins = Math.floor((diff / (1000 * 60)) % 60)

  return `${days}d ${hours}h ${mins}m`
}

const EventCard: React.FC<{ event: Event }> = ({ event }) => {
  const isUpcoming = event.status === "upcoming"
  const storageKey = `event-registered-${event.id}`

  const [countdown, setCountdown] = useState("")
  const [registered, setRegistered] = useState<boolean>(
    localStorage.getItem(storageKey) === "yes"
  )

  useEffect(() => {
    if (isUpcoming) {
      const timer = setInterval(() => {
        setCountdown(getCountdown(event.date))
      }, 60000)
      setCountdown(getCountdown(event.date))
      return () => clearInterval(timer)
    }
  }, [event.date, isUpcoming])

  const handleRegister = () => {
    localStorage.setItem(storageKey, "yes")
    setRegistered(true)
  }

  return (
    <div className={`event-card ${isUpcoming ? "upcoming" : "past"}`}>
      <div className="event-date">
        <span>{formatDate(event.date)}</span>
        {isUpcoming && countdown && (
          <div className="countdown">{countdown}</div>
        )}
      </div>

      <div className="event-content">
        <h3>{event.title}</h3>
        <div className="event-meta">
          <span className={`badge type ${event.type}`}>{event.type}</span>
          <span className="location">{event.location}</span>
        </div>

        {isUpcoming ? (
         <span></span>
        ) : (
          <a
            className="action-button"
            href="#"
            onClick={(e) => {
              e.preventDefault()
              alert("Video coming soon!")
            }}
          >
            Watch Recording
          </a>
        )}
      </div>
    </div>
  )
}

export default EventCard
